import { Vue, Component } from 'vue-property-decorator';
import { FEEDBACK_TYPES, FEEDBACK_STATUSES, NOTIFICATION } from '@/constants';
import { FeedbackRequestDTO, SelectionOptions, UserDTO } from '@/models';
import { createFeedback } from '@/services';
import { startCase, toLower } from 'lodash';

@Component
export default class FeedbackBox extends Vue {
  $refs!: {
    formRef: HTMLFormElement;
  };
  private expanded = false;
  private feedbackOptions: SelectionOptions = [];
  private feedbackObj: FeedbackRequestDTO = {
    type: FEEDBACK_TYPES.GIVE_FEEDBACK,
    description: '',
    status: '',
    image: null,
  };
  private ruleOptions = {
    description: [(v: string) => !!v || 'Description is required'],
    image: [() => this.isImageValid() || 'Image must be PNG, JPG or JPEG']
  };

  toggleFeedbackBox(): void {
    this.expanded = !this.expanded;
  }

  onFeedbackTypeChanged(selectedFeedbackType: string): void {
    this.feedbackObj.type = selectedFeedbackType;
  }

  resetForm(): void {
    this.$refs.formRef.reset();
    this.feedbackObj.type = FEEDBACK_TYPES.GIVE_FEEDBACK;
  }

  isImageValid(): boolean {
    const acceptedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
    return !this.feedbackObj.image || acceptedTypes.includes(this.feedbackObj.image.type);
  }

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  async created(): Promise<void> {
    Object.values(FEEDBACK_TYPES).forEach(item => {
      this.feedbackOptions.push({ text: startCase(toLower(item)), value: item });
    });
  }

  async createNewFeedback(): Promise<void> {
    if (this.formValidate()) {
      const body: FeedbackRequestDTO = {
        type: this.feedbackObj.type,
        description: this.feedbackObj.description,
        status: FEEDBACK_STATUSES.PENDING.label,
        image: this.feedbackObj.image
      };
      const response = await createFeedback(body);
      const requestInfoFeedbackSuccess = {
        showing: true,
        type: response.data ? NOTIFICATION.TYPE.success : NOTIFICATION.TYPE.error,
        title: response.data ? NOTIFICATION.TEXT.sendFeedbackSuccess : NOTIFICATION.TEXT.sendFeedbackFailed,
        content: [],
        icon: response.data ? NOTIFICATION.ICON.success : NOTIFICATION.ICON.error,
        multiline: false,
        height: 0
      };
      this.$store.commit('notification/setNotification', requestInfoFeedbackSuccess);
      this.expanded = false;
      this.resetForm();
    }
  }
}
